import { Box, Grid, Typography } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	FieldLayout,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface IManageWageAccountHeaderFieldsPanel extends ITest {
	wageAccountTypeDDL: any;
	postingAccountDDL: any;
}

export const ManageWageAccountHeaderFieldsPanel: FC<
	IManageWageAccountHeaderFieldsPanel
> = ({ wageAccountTypeDDL, postingAccountDDL,
}) => {

		return (
			<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ display: "flex" }}>
				<Grid size={{ xs: 6, sm: 6, md: 4, lg: 4, xl: 4 }}>
					<EnhancedDropDownRHFWithLabel
						selectName="wageAccountType"
						label="Wage Account Type"
						selectedItem={"all"}
						testId="wage-account-type"
						labelPosition={LabelPosition.Top}
						items={wageAccountTypeDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
				
					/>
					<EnhancedDropDownRHFWithLabel
						selectName="postingAccount"
						label="Posting Account"
						selectedItem={"all"}
						testId="posting-account"
						labelPosition={LabelPosition.Top}
						items={postingAccountDDL ?? []}
						labelColumns={4}
						fieldColumns={8}
					
					/>
					<EnhancedButtonPrimeReact
						label="Load"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						// onClickHandler={onLoadClickedHandler}
						type="submit"
					/>
				</Grid>

			</Grid>
		);
	};
